import React from 'react';
import GiftFinderApp from '../components/GiftFinder/GiftFinderApp';

const GiftFinderPage = ({ setCurrentPage }) => {
  return (
    <div>
      <GiftFinderApp setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default GiftFinderPage;